import { useEffect, useMemo, useState } from 'react';

export const useVimeoThumbnails = (
  source: string | null,
  videoId: string | null
) => {
  const [vimeoThumbnails, setVimeoThumbnails] = useState<Record<
    string,
    string
  > | null>(null);

  useEffect(() => {
    if (source !== 'vimeo') {
      return;
    }

    (async () => {
      const apiUrl = `https://vimeo.com/api/v2/video/${videoId}.json`;

      try {
        const response = await fetch(apiUrl);
        const data = await response.json();

        if (data && data.length > 0) {
          const [
            {
              thumbnail_large: largeVimeoThumbnail,
              thumbnail_medium: smallVimeoThumbnail
            }
          ] = data;

          setVimeoThumbnails({
            large: largeVimeoThumbnail,
            small: smallVimeoThumbnail,
            small2x: largeVimeoThumbnail,
            large2x: largeVimeoThumbnail
          });
        }
      } catch (_) {
        setVimeoThumbnails(null);
      }

      return null;
    })();
  }, [source, videoId]);

  return useMemo(() => vimeoThumbnails, [source, videoId, vimeoThumbnails]);
};
